/**
 * Presentation timestamps use the browser media clock's integer microsecond
 * precision. Keeping the conversion here prevents boundary checks in the
 * player, tracker, and inspector from drifting apart.
 */
export const PRESENTATION_TIME_SCALE = 1_000_000;

export function toPresentationUs(seconds: number): number {
  return Math.round(seconds * PRESENTATION_TIME_SCALE);
}

export function fromPresentationUs(microseconds: number): number {
  return microseconds / PRESENTATION_TIME_SCALE;
}

export function quantizePresentationTime(seconds: number): number {
  return fromPresentationUs(toPresentationUs(seconds));
}

export function formatSeconds(seconds: number): string {
  return `${seconds.toFixed(3)}s`;
}
